import { render } from "./Session.vue?vue&type=template&id=1f62eb23&ts=true"
import script from "./Session.vue?vue&type=script&lang=ts"
export * from "./Session.vue?vue&type=script&lang=ts"

import "./Session.vue?vue&type=style&index=0&id=1f62eb23&lang=css"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Session.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f62eb23"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f62eb23', __exports__)) {
    api.reload('1f62eb23', __exports__)
  }
  
  module.hot.accept("./Session.vue?vue&type=template&id=1f62eb23&ts=true", () => {
    api.rerender('1f62eb23', render)
  })

}


export default __exports__